module.exports = __webpack_public_path__ + "static/media/mimi1.477fc8dd.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/mimi1.gif
// module id = 294
// module chunks = 0